<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="TerminalId" label="标识" width="">
        </el-table-column>
        <el-table-column prop="TerminalName" label="名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门" width="">
        </el-table-column>
        <el-table-column prop="LicensePlate" label="车牌" width="">
        </el-table-column>
        <el-table-column prop="Model" label="车辆型号" width="">
        </el-table-column>
        <el-table-column prop="SeatNumber" label="总座位" width="">
        </el-table-column>
        <el-table-column prop="DriverName" label="司机姓名" width="">
        </el-table-column>
        <el-table-column prop="DriverPhone" label="司机电话" width="">
        </el-table-column>
        <el-table-column prop="TerminalDesc" label="备注" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="添加时间">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="ShowFollowTeacher(scope.row)" type="text">跟着人管理</el-button>
            <el-button @click="ShowPassenger(scope.row)" type="text">乘坐人管理</el-button>
          </template>
        </el-table-column>

      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑终端信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">

          <el-form-item label="标识" prop="TerminalId">
            <el-input v-model="editForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="名称" prop="TerminalName">
            <el-input v-model="editForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>
          
          <el-form-item label="车牌" prop="LicensePlate">
            <el-input v-model="editForm.LicensePlate" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="车辆型号" prop="Model">
            <el-input v-model="editForm.Model" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="总座位" prop="SeatNumber">
            <el-input-number v-model="editForm.SeatNumber" :min="0" :controls="true" :step="1"></el-input-number>
          </el-form-item>

          <el-form-item label="司机姓名" prop="DriverName">
            <el-input v-model="editForm.DriverName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="司机联系电话" prop="DriverPhone">
            <el-input v-model="editForm.DriverPhone" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="editForm.TerminalDesc"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增终端信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <el-form-item label="标识" prop="TerminalId">
            <el-input v-model="addForm.TerminalId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="名称" prop="TerminalName">
            <el-input v-model="addForm.TerminalName" auto-complete="off"></el-input>
          </el-form-item>



          <el-form-item label="车牌" prop="LicensePlate">
            <el-input v-model="addForm.LicensePlate" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="车辆型号" prop="Model">
            <el-input v-model="addForm.Model" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="总座位" prop="SeatNumber">
            <el-input-number v-model="addForm.SeatNumber" :min="0" :controls="true" :step="1"></el-input-number>
          </el-form-item>

          <el-form-item label="司机姓名" prop="DriverName">
            <el-input v-model="addForm.DriverName" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="司机联系电话" prop="DriverPhone">
            <el-input v-model="addForm.DriverPhone" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="addForm.TerminalDesc"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--跟车人-->
      <el-dialog :title="followTeacherTitle" :visible.sync="followTeacherDialogVisible" center
        @close="followTeacherHandleClose">

        <div style="display: flex;justify-content: flex-end;">
          <el-button type="primary" @click="addFollowTeacher()" style="float: right;">新增</el-button>
          <el-button type="danger" @click="delFollowTeacher()" style="float: right;">删除</el-button>
        </div>

        <el-table :data="followTeacherData" v-loading="listLoading" @select="followTeacherCheck"
          ref="followTeacherTable" @row-click="followTeacherSelectCurrentRow" class="custom-tbl" style="width: 100%">
          <el-table-column type="selection"> </el-table-column>
          <el-table-column property="UserName" label="姓名"></el-table-column>
          <el-table-column property="UserPhone" label="号码"></el-table-column>
          <el-table-column property="Desc" label="描述"></el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="followTeacherHandleCurrentChange" :page-size="10"
            :total="followTeacherTotal" style="float: right">
          </el-pagination>
        </el-col>

        <el-dialog width="40%" title="新增跟车老师" :visible.sync="followTeacherInnerVisible" append-to-body>
          <el-form label-width="80px" :rules="followTeacherFormRules" ref="followTeacherForm">

            <el-form-item label="教师人员" prop="TeacherId">
              <el-select v-model="followTeacherForm.TeacherId" placeholder="请选择" filterable multiple
                style="width: 100%;">
                <el-option v-for="item in teacherMasterList" :key="item.Id" :label="item.TeacherName" :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="描述" prop="Desc">
              <el-input v-model="followTeacherForm.Desc" autocomplete="off"></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="followTeacherInnerVisible = false">取 消</el-button>
            <el-button type="primary" @click.native="savaFollowTeacherSubmit" :loading="addLoading">提交</el-button>
          </div>
        </el-dialog>

        <div slot="footer" class="dialog-footer">
          <el-button @click="followTeacherDialogVisible = false">取 消</el-button>
        </div>

      </el-dialog>

      <!--乘坐人-->
      <el-dialog
        :title="PassengerTitle"
        :visible.sync="PassengerDialogVisible"
        width="720px"
        custom-class="schoolbus-sub-dialog"
        @close="PassengerHandleClose"
      >
        <div class="schoolbus-sub-dialog__actions">
          <el-button type="primary" size="small" @click="addPassenger()">新增</el-button>
          <el-button type="danger" size="small" @click="delPassenger()">删除</el-button>
        </div>

        <el-table
          :data="PassengerData"
          v-loading="listLoading"
          @select="PassengerCheck"
          ref="PassengerTable"
          @row-click="PassengerSelectCurrentRow"
          class="custom-tbl"
          max-height="420"
          style="width: 100%"
        >
          <el-table-column type="selection" width="48" />
          <el-table-column property="UserName" label="姓名" min-width="100" show-overflow-tooltip />
          <el-table-column property="UserPhone" label="号码" min-width="120" show-overflow-tooltip />
          <el-table-column property="UserCardId" label="卡号" min-width="140" show-overflow-tooltip />
          <el-table-column property="UserPhone" label="联系方式" min-width="120" show-overflow-tooltip />
        </el-table>

        <div class="schoolbus-sub-dialog__pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            @current-change="PassengerHandleCurrentChange"
            :current-page.sync="PassengerPage"
            :page-size="PassengerPageSize"
            :total="PassengerTotal"
          />
        </div>

        <el-dialog width="520px" title="新增乘坐人" :visible.sync="PassengerInnerVisible" append-to-body>
          <el-form label-width="80px" :rules="PassengerFormRules" ref="PassengerForm">
            <el-form-item label="人员" prop="UserId" required>
              <div class="ps-pick-summary">
                <span v-if="personSelectedItems.length">已选 <strong>{{ personSelectedItems.length }}</strong> 人</span>
                <span v-else class="muted-text">请从家校通讯录选择学生</span>
                <el-button type="primary" size="small" plain @click="openPassengerPersonPicker">选择学生</el-button>
                <el-button v-if="personSelectedItems.length" type="text" size="small" @click="clearPersonSelection">清空</el-button>
              </div>
              <div v-if="personSelectedItems.length" class="ps-pick-tags">
                <el-tag
                  v-for="item in personSelectedPreview"
                  :key="item.id"
                  size="mini"
                  closable
                  disable-transitions
                  @close="removePersonSelected(item.id)">
                  {{ item.name }}
                </el-tag>
                <span v-if="personSelectedItems.length > 8" class="ps-pick-more">等 {{ personSelectedItems.length }} 人</span>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="PassengerInnerVisible = false">取 消</el-button>
            <el-button type="primary" @click.native="savaPassengerSubmit" :loading="addLoading">提交</el-button>
          </div>
        </el-dialog>

        <person-scope-multi-picker-dialog
          :visible.sync="personPickerVisible"
          directory-scope="teaching"
          :show-scope-tabs="false"
          :scope-department-id="DepartmentId"
          title="选择学生"
          :value="personSelectedItems"
          @confirm="onPersonsPicked"
        />

        <div slot="footer" class="dialog-footer">
          <el-button @click="PassengerDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getSchoolBusTerminalListPage, removeSchoolBusTerminal, editSchoolBusTerminal, addSchoolBusTerminal } from '../../api/modules/attendance';
import { BaseApiUrl } from '../../api/base';
import { getTeacherMasterList, addSchoolBusFollowTeacher, getSchoolBusFollowTeacher, removeSchoolBusFollowTeacher } from '../../api/modules/personnel';
import { addSchoolBusPassenger, getSchoolBusPassenger, removeSchoolBusPassenger } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'

export default {
  components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '终端名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        TerminalId: [
          { required: true, message: "请输入标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        TerminalId: "",
        TerminalName: "",
        LicensePlate: "",
        Model: "",
        SeatNumber: 0,
        DriverName: "",
        DriverPhone: "",
        TerminalDesc: "",
        DepartmentId: 0
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        TerminalId: [
          { required: true, message: "请输入标识", trigger: "blur" },
        ],
        TerminalName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        TerminalId: "",
        TerminalName: "",
        LicensePlate: "",
        Model: "",
        SeatNumber: 0,
        DriverName: "",
        DriverPhone: "",
        TerminalDesc: "",
        DepartmentId: 0
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      teacherMasterList: [],
      //跟车人
      followTeacherDialogVisible: false,
      followTeacherTitle: "",
      followTeacherData: [],
      currentfollowTeacherRow: null,
      followTeacherInnerVisible: false,
      followTeacherFormRules: {

      },
      followTeacherForm: {
        Desc: "",
        TeacherId: [],
        SchoolBusId: ""
      },
      followTeacherTotal: 0,
      followTeacherPage: 1,

      //乘坐人
      PassengerDialogVisible: false,
      PassengerTitle: "",
      PassengerData: [],
      currentPassengerRow: null,
      PassengerInnerVisible: false,
      PassengerFormRules: {

      },
      PassengerForm: {
        Desc: "",
        UserId: [],
        SchoolBusId: ""
      },
      PassengerTotal: 0,
      PassengerPage: 1,
      PassengerPageSize: 10,
      personSelectedItems: [],
      personPickerVisible: false,
    };
  },
  computed: {
    personSelectedPreview() {
      return (this.personSelectedItems || []).slice(0, 8);
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    followTeacherHandleCurrentChange(val) {
      this.followTeacherPage = val;
      this.handleFollowTeacherQuery();
    },

    PassengerHandleCurrentChange(val) {
      this.PassengerPage = val;
      this.handlePassengerQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: "0"
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getSchoolBusTerminalListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeSchoolBusTerminal(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        TerminalId: "",
        TerminalName: "",
        LicensePlate: "",
        Model: "",
        SeatNumber: 0,
        DriverName: "",
        DriverPhone: "",
        TerminalDesc: "",
        DepartmentId: this.DepartmentId
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editSchoolBusTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addSchoolBusTerminal(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },

    //跟车人
    ShowFollowTeacher(row) {
      this.currentRow = row;
      this.followTeacherTitle = "校车跟车老师管理(" + row.TerminalName + ")";
      this.followTeacherDialogVisible = true;
      this.followTeacherPage = 1;
      this.handleFollowTeacherQuery();
    },

    followTeacherHandleClose() {
      this.currentfollowTeacherRow = null;
      this.followTeacherData = []
    },

    //跟车人table选中
    followTeacherCheck(selection, row) {
      this.currentfollowTeacherRow = null;
      this.$refs.followTeacherTable.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.followTeacherSelectCurrentRow(row)
      }
    },

    //跟车人table选中
    followTeacherSelectCurrentRow(val) {
      if (val) {
        this.currentfollowTeacherRow = val
        this.$refs.followTeacherTable.clearSelection()
        this.$refs.followTeacherTable.toggleRowSelection(val, true)
      }
    },

    addFollowTeacher() {
      this.followTeacherForm = {
        Desc: "",
        TeacherId: [],
        SchoolBusId: this.currentRow.Id
      }
      this.followTeacherInnerVisible = true;
      let par = { departmentId: this.DepartmentId };
      getTeacherMasterList(par).then((res) => {
        this.teacherMasterList = res.data.response;
      });
    },

    savaFollowTeacherSubmit() {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        addSchoolBusFollowTeacher(this.followTeacherForm).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.followTeacherInnerVisible = false;
          this.handleFollowTeacherQuery();
        });
      });
    },

    //获取跟车人
    handleFollowTeacherQuery() {
      let para = {
        page: this.followTeacherPage,
        schoolBusId: this.currentRow.Id
      }
      this.listLoading = true;
      getSchoolBusFollowTeacher(para).then((res) => {
        this.followTeacherTotal = res.data.response.dataCount;
        this.followTeacherData = res.data.response.data;
        this.listLoading = false;
      });
    },

    delFollowTeacher() {
      let row = this.currentfollowTeacherRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeSchoolBusFollowTeacher(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleFollowTeacherQuery();
          });
        })
        .catch(() => { });
    },

    //乘坐人
    ShowPassenger(row) {
      this.currentRow = row;
      this.PassengerTitle = "校车乘坐人管理(" + row.TerminalName + ")";
      this.PassengerDialogVisible = true;
      this.PassengerPage = 1;
      this.handlePassengerQuery();
    },

    PassengerHandleClose() {
      this.currentPassengerRow = null;
      this.PassengerData = []
    },

    //乘坐人table选中
    PassengerCheck(selection, row) {
      this.currentPassengerRow = null;
      this.$refs.PassengerTable.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.PassengerSelectCurrentRow(row)
      }
    },

    //乘坐人table选中
    PassengerSelectCurrentRow(val) {
      if (val) {
        this.currentPassengerRow = val
        this.$refs.PassengerTable.clearSelection()
        this.$refs.PassengerTable.toggleRowSelection(val, true)
      }
    },

    addPassenger() {
      this.PassengerForm = {
        Desc: "",
        UserId: [],
        SchoolBusId: this.currentRow.Id
      }
      this.clearPersonSelection();
      this.PassengerInnerVisible = true;
    },
    openPassengerPersonPicker() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.personPickerVisible = true;
    },
    onPersonsPicked(people) {
      this.personSelectedItems = (people || []).map((p) => ({
        id: String(p.id),
        name: p.name || String(p.id),
        personType: 'student',
        deptId: p.deptId != null ? String(p.deptId) : '0',
        deptLabel: p.deptLabel || '',
      }));
      this.syncPassengerUserIds();
    },
    clearPersonSelection() {
      this.personSelectedItems = [];
      if (this.PassengerForm) this.PassengerForm.UserId = [];
    },
    removePersonSelected(id) {
      const key = String(id);
      this.personSelectedItems = (this.personSelectedItems || []).filter((x) => String(x.id) !== key);
      this.syncPassengerUserIds();
    },
    /** UserId 形如 [deptId, userId][]，与后端 SchoolBusPassenger 一致 */
    syncPassengerUserIds() {
      this.PassengerForm.UserId = (this.personSelectedItems || []).map((item) => [
        String(item.deptId || '0'),
        String(item.id),
      ]);
    },
    savaPassengerSubmit() {
      if (!this.personSelectedItems.length) {
        this.$message.warning('请先选择人员');
        return;
      }
      this.syncPassengerUserIds();
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        addSchoolBusPassenger(this.PassengerForm).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.PassengerInnerVisible = false;
          this.clearPersonSelection();
          this.handlePassengerQuery();
        });
      });
    },

    //获取跟车人
    handlePassengerQuery() {
      let para = {
        page: this.PassengerPage,
        intPageSize: this.PassengerPageSize,
        schoolBusId: this.currentRow.Id
      }
      this.listLoading = true;
      getSchoolBusPassenger(para).then((res) => {
        this.PassengerTotal = res.data.response.dataCount;
        this.PassengerData = res.data.response.data;
        this.listLoading = false;
      });
    },

    delPassenger() {
      let row = this.currentPassengerRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeSchoolBusPassenger(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handlePassengerQuery();
          });
        })
        .catch(() => { });
    }
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}
.muted-text {
  color: #94a3b8;
}
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.schoolbus-sub-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

.schoolbus-sub-dialog__pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  overflow: hidden;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
